import { connect } from "react-redux";
import HistoryView from "../components/historyView";
import {
    ResetAppState,
    ToggleModal,
    GetScheduleVisitsCards,
    GetPendingFilesCards,
    GetPendingFilesLV,
    GetPatientInfo,
    GetHeaderInfo,
    GetNotes,
    ResetPatientInfo,
    GetProductInfo,
    GetSoapNoteInfo,
    GetConsultQuestions,
    SetProductInfo,
    GetProductList,
    GetQtyByProduct,
    SaveProductChanges,
    ToggleProductChangeModal,
    GetOrderNotes,
    GetPatientNotes,
    GetMedicalOrderNotes,
    GetMedicalPatientNotes,
    SetSelectedTab,
    GetEmail,
    GetHistory,
    ToggleErrorModal,
    ResetNotesTab,
} from "../data/app/appActions";
import { withRouter } from "react-router-dom";

const mapStateToProps = state => ({
    subscribed: state.appReducer.subscribed,
    loading: state.loaderReducer.loading,
    modalOpen: state.appReducer.modalOpen,
    selectedPatientInfo: state.appReducer.selectedPatientInfo,
    selectedPrescriberInfo: state.appReducer.selectedPrescriberInfo,
    notes: state.appReducer.notes,
    productInfo: state.appReducer.productInfo,
    productList: state.appReducer.productList,
    qtyByProduct: state.appReducer.qtyByProduct,
    productListModalError: state.appReducer.productListModalError,
    isProductChangeModalOpen: state.appReducer.isProductChangeModalOpen,
    consultQuestion: state.appReducer.consultQuestion,
    orderNotes: state.appReducer.orderNotes,
    patientNotes: state.appReducer.patientNotes,
    medicalOrderNotes: state.appReducer.medicalOrderNotes,
    medicalPatientNotes: state.appReducer.medicalPatientNotes,
    soapNoteInfo: state.appReducer.soapNoteInfo,
    selectedTab: state.appReducer.selectedTab,
    emailData: state.appReducer.emailData,
    historyData: state.appReducer.historyData,
    errorModalOpen: state.appReducer.errorModalOpen,
    scheduledVisits: state.appReducer.scheduledVisits,
    asyncOrders: state.appReducer.asyncOrders,
    getPdf: state.appReducer.getPdf,
});

const mapDispatchToProps = dispatch => ({
    ResetAppState: data => {
        dispatch(ResetAppState(data));
    },
    ToggleModal: data => {
        dispatch(ToggleModal(data));
    },
    GetScheduleVisitsCards: data => {
        dispatch(GetScheduleVisitsCards(data));
    },
    GetPendingFilesCards: () => dispatch(GetPendingFilesCards()),
    GetPendingFilesLV: () => dispatch(GetPendingFilesLV()),
    GetPatientInfo: data => {
        dispatch(GetPatientInfo(data));
    },
    ResetPatientInfo: data => {
        dispatch(ResetPatientInfo(data));
    },
    GetHeaderInfo: data => {
        dispatch(GetHeaderInfo(data));
    },
    GetProductInfo: data => dispatch(GetProductInfo(data)),
    GetSoapNoteInfo: data => {
        dispatch(GetSoapNoteInfo(data));
    },
    GetNotes: data => {
        dispatch(GetNotes(data));
    },
    SetProductInfo: data => {
        dispatch(SetProductInfo(data));
    },
    GetProductList: data => dispatch(GetProductList(data)),
    GetQtyByProduct: data => {
        dispatch(GetQtyByProduct(data));
    },
    SaveProductChanges: data => {
        dispatch(SaveProductChanges(data));
    },
    ToggleProductChangeModal: data => {
        dispatch(ToggleProductChangeModal(data));
    },
    GetConsultQuestions: data => {
        dispatch(GetConsultQuestions(data));
    },
    GetOrderNotes: data => {
        dispatch(GetOrderNotes(data));
    },
    GetPatientNotes: data => {
        dispatch(GetPatientNotes(data));
    },
    GetMedicalOrderNotes: (data) => {
        dispatch(GetMedicalOrderNotes(data));
    },
    GetMedicalPatientNotes: (data) => {
        dispatch(GetMedicalPatientNotes(data));
    },
    SetSelectedTab: data => {
        dispatch(SetSelectedTab(data));
    },
    GetEmail: data => {
        dispatch(GetEmail(data));
    },
    GetHistory: data => {
        dispatch(GetHistory(data));
    },
    ToggleErrorModal: (data) => {
        dispatch(ToggleErrorModal(data));
    },
    ResetNotesTab: (data) => {
        dispatch(ResetNotesTab(data));
    },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HistoryView));
